import React from "react";
import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

const LegalBody = ({ sections, updated }) => (
  <section className="bg-[#F7F8F5] py-20 md:py-28">
    <div className="max-w-[820px] mx-auto px-6 md:px-10">
      <p className="text-xs text-slate-500 mb-12">{updated}: 2026-06</p>
      {sections.map((s, i) => (
        <Reveal key={s.h} delay={Math.min(i * 0.05, 0.3)} y={14}>
          <div className="mb-10">
            <h2 className="text-lg md:text-xl font-semibold text-[#061A26]">{s.h}</h2>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.p}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export function PrivacyPage() {
  const { t } = useLang();
  return (
    <>
      <SEO page="privacy" />
      <PageHero eyebrow="NORTIS" title={t.legal.privacyTitle} testId="privacy-hero" />
      <LegalBody sections={t.legal.privacy} updated={t.legal.updated} />
    </>
  );
}

export function TermsPage() {
  const { t } = useLang();
  return (
    <>
      <SEO page="terms" />
      <PageHero eyebrow="NORTIS" title={t.legal.termsTitle} testId="terms-hero" />
      <LegalBody sections={t.legal.terms} updated={t.legal.updated} />
    </>
  );
}
